import { render, staticRenderFns } from "./PeriodoIncidencias.vue?vue&type=template&id=17fb6b05&scoped=true"
import script from "./PeriodoIncidencias.vue?vue&type=script&lang=js"
export * from "./PeriodoIncidencias.vue?vue&type=script&lang=js"
import style0 from "./PeriodoIncidencias.vue?vue&type=style&index=0&id=17fb6b05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fb6b05",
  null
  
)

export default component.exports